export default {
  activity: {
    include_activity_owner: true,
    include_activity_owner_image: true,
  },
  comment: {
    include_comment_user: true,
  },
  conversation: {
    include_conversation_comments: true,
    skip_notifications: true,
  },
  image: {
    include_image_sizes: true,
  },
  user: {
    include_user_image: true,
  },
}
